<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'BreadcrumbNavigation',

  props: {
    items: {
      type: Array as PropType<Record<'label' | 'to', string>[]>,
      required: true,
    },
  },

  setup(props) {
    /**
     * 指定されたパンくずアイテムが現在ページかどうか
     * @param index パンくずアイテムの判定対象の index
     */
    const isCurrent = (index: number): boolean => {
      return index === (props.items.length - 1)
    }

    return {
      // methods
      isCurrent,
    }
  },
})
</script>

<template>
  <nav class="o-list__breadcrumb">
    <ol
      class="o-list__breadcrumb--items"
      itemscope
      itemtype="https://schema.org/BreadcrumbList">
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="[
          'o-list__breadcrumb--item',
          { 'is-current': isCurrent(index) },
        ]"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem">
        <template v-if="isCurrent(index)">
          <span
            class="span"
            itemprop="name">
            {{ item.label }}
          </span>
        </template>
        <template v-else>
          <div class="o-action__breadcrumb">
            <a
              class="o-action__breadcrumb--item"
              :href="item.to"
              itemprop="item">
              <span
                class="span"
                itemprop="name">
                {{ item.label }}

              </span>
            </a>
          <!-- /.o-action__breadcrumb --></div>
        </template>
        <meta
          class="meta"
          itemprop="position"
          :content="(index + 1).toString()">
      </li>
    </ol>
  <!-- /.o-list__breadcrumb --></nav>
</template>

<style lang="sass" scoped>
// object
.o-list__breadcrumb
  $root: &

  & &--items
    display: flex

  $arrow-size: 0.25em
  $margin-size: 0.7em
  & &--item
    flex-shrink: 0
    position: relative
    overflow: hidden
    line-height: 1
    color: $font-gray
    font-size: $font-x-small
    text-overflow: ellipsis
    margin-left: 0.5em
    padding-left: $arrow-size * 2 + $margin-size
    white-space: nowrap

    &::before
      content: ""
      width: $arrow-size
      height: $arrow-size
      display: block
      position: absolute
      left: 0
      top: 50%
      transform: rotate(45deg) translateY(-50%)
      border-top: 1px solid $border-x-dark-gray
      border-right: 1px solid $border-x-dark-gray

    &:first-child
      margin-left: 0
      padding-left: 0

      &::before
        display: none

    &:last-child
      flex-shrink: 1

    &.is-current
      font-weight: bold

.o-action__breadcrumb
  & &--item
    color: $font-gray
    text-decoration: none
</style>

